// office
export const GET_OFFICE: { [x: string]: any } = {
  LOADING: "OFFICE_GET_LOADING",
  SUCCESS: "OFFICE_GET_SUCCESS",
  ERROR: "OFFICE_GET_ERROR",
};

export const CREATE_OFFICE: { [x: string]: any } = {
  LOADING: "OFFICE_CREATE_LOADING",
  SUCCESS: "OFFICE_CREATE_SUCCESS",
  ERROR: "OFFICE_CREATE_ERROR",
};

export const UPDATE_OFFICE: { [x: string]: any } = {
  LOADING: "OFFICE_UPDATE_LOADING",
  SUCCESS: "OFFICE_UPDATE_SUCCESS",
  ERROR: "OFFICE_UPDATE_ERROR",
};

export const DELETE_OFFICE: { [x: string]: any } = {
  LOADING: "OFFICE_DELETE_LOADING",
  SUCCESS: "OFFICE_DELETE_SUCCESS",
  ERROR: "OFFICE_DELETE_ERROR",
};

// desk

export const GET_DESK: { [x: string]: any } = {
  LOADING: "DESK_GET_LOADING",
  SUCCESS: "DESK_GET_SUCCESS",
  ERROR: "DESK_GET_ERROR",
};

export const GET_SINGLE_DESK: { [x: string]: any } = {
  LOADING: "DESK_SINGLE_GET_LOADING",
  SUCCESS: "DESK_SINGLE_GET_SUCCESS",
  ERROR: "DESK_SINGLE_GET_ERROR",
};

export const CREATE_DESK: { [x: string]: any } = {
  LOADING: "DESK_CREATE_LOADING",
  SUCCESS: "DESK_CREATE_SUCCESS",
  ERROR: "DESK_CREATE_ERROR",
};

export const UPDATE_DESK: { [x: string]: any } = {
  LOADING: "DESK_UPDATE_LOADING",
  SUCCESS: "DESK_UPDATE_SUCCESS",
  ERROR: "DESK_UPDATE_ERROR",
};

export const DELETE_DESK: { [x: string]: any } = {
  LOADING: "DESK_DELETE_LOADING",
  SUCCESS: "DESK_DELETE_SUCCESS",
  ERROR: "DESK_DELETE_ERROR",
};

// building

export const GET_BUILDING: { [x: string]: any } = {
  LOADING: "BUILDING_GET_LOADING",
  SUCCESS: "BUILDING_GET_SUCCESS",
  ERROR: "BUILDING_GET_ERROR",
};

export const GET_BUILDING_DETAILS: { [x: string]: any } = {
  LOADING: "BUILDING_DETAILS_GET_LOADING",
  SUCCESS: "BUILDING_DETAILS_GET_SUCCESS",
  ERROR: "BUILDING_DETAILS_GET_ERROR",
};

export const CREATE_BUILDING: { [x: string]: any } = {
  LOADING: "BUILDING_CREATE_LOADING",
  SUCCESS: "BUILDING_CREATE_SUCCESS",
  ERROR: "BUILDING_CREATE_ERROR",
};

export const UPDATE_BUILDING: { [x: string]: any } = {
  LOADING: "BUILDING_UPDATE_LOADING",
  SUCCESS: "BUILDING_UPDATE_SUCCESS",
  ERROR: "BUILDING_UPDATE_ERROR",
};

export const DELETE_BUILDING: { [x: string]: any } = {
  LOADING: "BUILDING_DELETE_LOADING",
  SUCCESS: "BUILDING_DELETE_SUCCESS",
  ERROR: "BUILDING_DELETE_ERROR",
};

// room types

export const GET_ROOM_TYPES: { [x: string]: any } = {
  LOADING: "ROOM_TYPES_GET_LOADING",
  SUCCESS: "ROOM_TYPES_GET_SUCCESS",
  ERROR: "ROOM_TYPES_GET_ERROR",
};

export const GET_SINGLE_ROOM_TYPES: { [x: string]: any } = {
  LOADING: "ROOM_TYPES_SINGLE_GET_LOADING",
  SUCCESS: "ROOM_TYPES_SINGLE_GET_SUCCESS",
  ERROR: "ROOM_TYPES_SINGLE_GET_ERROR",
};

export const CREATE_ROOM_TYPES: { [x: string]: any } = {
  LOADING: "ROOM_TYPES_CREATE_LOADING",
  SUCCESS: "ROOM_TYPES_CREATE_SUCCESS",
  ERROR: "ROOM_TYPES_CREATE_ERROR",
};

export const UPDATE_ROOM_TYPES: { [x: string]: any } = {
  LOADING: "ROOM_TYPES_UPDATE_LOADING",
  SUCCESS: "ROOM_TYPES_UPDATE_SUCCESS",
  ERROR: "ROOM_TYPES_UPDATE_ERROR",
};

export const DELETE_ROOM_TYPES: { [x: string]: any } = {
  LOADING: "ROOM_TYPES_DELETE_LOADING",
  SUCCESS: "ROOM_TYPES_DELETE_SUCCESS",
  ERROR: "ROOM_TYPES_DELETE_ERROR",
};

// room

export const GET_ROOM: { [x: string]: any } = {
  LOADING: "ROOM_GET_LOADING",
  SUCCESS: "ROOM_GET_SUCCESS",
  ERROR: "ROOM_GET_ERROR",
};

export const SINGLE_GET_ROOM: { [x: string]: any } = {
  LOADING: "ROOM_SINGLE_GET_LOADING",
  SUCCESS: "ROOM_SINGLE_GET_SUCCESS",
  ERROR: "ROOM_SINGLE_GET_ERROR",
};

export const CREATE_ROOM: { [x: string]: any } = {
  LOADING: "ROOM_CREATE_LOADING",
  SUCCESS: "ROOM_CREATE_SUCCESS",
  ERROR: "ROOM_CREATE_ERROR",
};

export const UPDATE_ROOM: { [x: string]: any } = {
  LOADING: "ROOM_UPDATE_LOADING",
  SUCCESS: "ROOM_UPDATE_SUCCESS",
  ERROR: "ROOM_UPDATE_ERROR",
};

export const DELETE_ROOM: { [x: string]: any } = {
  LOADING: "ROOM_DELETE_LOADING",
  SUCCESS: "ROOM_DELETE_SUCCESS",
  ERROR: "ROOM_DELETE_ERROR",
};
